module.exports = __webpack_public_path__ + "img/stop.a041ac74.png";